import o from "clsx";
import e from "react";
import { s as r } from "../../../../../RideIcon.module-BjMwOP4j.mjs";
function p({
  size: C = "small",
  accessibilityTitle: t = "ricon tow truck light",
  className: n,
  "data-testid": l
}) {
  const a = () => o(n, r["ride-icon"], {
    [r[`size-${C}`]]: C
  });
  return /* @__PURE__ */ e.createElement("div", { className: a(), "data-testid": l }, /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "64",
      height: "64",
      viewBox: "0 0 64 64",
      fill: "none",
      stroke: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    t && /* @__PURE__ */ e.createElement("title", null, t),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M5.99988 36H27.9999V31.87C27.9958 31.1451 27.7294 30.4462 27.2499 29.9025L13.9999 14.6525V6.8125L35.9999 23.3125V14C35.9999 12.9391 36.4213 11.9217 37.1714 11.1716C37.9216 10.4214 38.939 10 39.9999 10H52.6149C53.4293 10.0015 54.224 10.2504 54.8938 10.7139C55.5635 11.1773 56.0765 11.8333 56.3649 12.595L60.8649 24.58C61.62 26.6022 62.0045 28.7439 61.9999 30.9025V48C61.9999 49.0609 61.5785 50.0783 60.8283 50.8284C60.0782 51.5786 59.0607 52 57.9999 52H55.9999C55.9999 54.1217 55.157 56.1566 53.6567 57.6569C52.1564 59.1571 50.1216 60 47.9999 60C45.8781 60 43.8433 59.1571 42.343 57.6569C40.8427 56.1566 39.9999 54.1217 39.9999 52H21.9999C21.9999 54.1217 21.157 56.1566 19.6567 57.6569C18.1564 59.1571 16.1216 60 13.9999 60C11.8781 60 9.84331 59.1571 8.34302 57.6569C6.84273 56.1566 5.99988 54.1217 5.99988 52C4.93901 52 3.92159 51.5786 3.17145 50.8284C2.4213 50.0783 1.99988 49.0609 1.99988 48V40C1.99988 38.9391 2.4213 37.9217 3.17145 37.1716C3.92159 36.4214 4.93901 36 5.99988 36ZM35.9999 28.55L22.1274 17.9025L30.2799 27.275C31.3888 28.549 31.9997 30.181 31.9999 31.87V36H35.9999V28.55ZM57.1074 25.985L52.6074 14H47.9999V29.9475H57.9649C57.8734 28.592 57.5845 27.2571 57.1074 25.985ZM47.9999 56C48.791 56 49.5644 55.7654 50.2222 55.3259C50.8799 54.8864 51.3926 54.2616 51.6954 53.5307C51.9981 52.7998 52.0774 51.9956 51.923 51.2196C51.7687 50.4437 51.3877 49.731 50.8283 49.1716C50.2689 48.6122 49.5562 48.2312 48.7802 48.0769C48.0043 47.9225 47.2001 48.0017 46.4691 48.3045C45.7382 48.6072 45.1135 49.1199 44.674 49.7777C44.2345 50.4355 43.9999 51.2089 43.9999 52C43.9999 53.0609 44.4213 54.0783 45.1714 54.8284C45.9216 55.5786 46.939 56 47.9999 56ZM13.9999 56C14.791 56 15.5644 55.7654 16.2222 55.3259C16.8799 54.8864 17.3926 54.2616 17.6954 53.5307C17.9981 52.7998 18.0774 51.9956 17.923 51.2196C17.7687 50.4437 17.3877 49.731 16.8283 49.1716C16.2689 48.6122 15.5562 48.2312 14.7802 48.0769C14.0043 47.9225 13.2001 48.0017 12.4691 48.3045C11.7382 48.6072 11.1135 49.1199 10.674 49.7777C10.2345 50.4355 9.99988 51.2089 9.99988 52C9.99988 53.0609 10.4213 54.0783 11.1714 54.8284C11.9216 55.5786 12.939 56 13.9999 56ZM5.99988 48H7.07237C7.77461 46.7842 8.78448 45.7746 10.0005 45.0727C11.2165 44.3707 12.5958 44.0012 13.9999 44.0012C15.4039 44.0012 16.7833 44.3707 17.9993 45.0727C19.2153 45.7746 20.2251 46.7842 20.9274 48H41.0724C41.7746 46.7842 42.7845 45.7746 44.0005 45.0727C45.2165 44.3707 46.5958 44.0012 47.9999 44.0012C49.4039 44.0012 50.7833 44.3707 51.9993 45.0727C53.2153 45.7746 54.2251 46.7842 54.9274 48H57.9999V33.9475H43.9999V14H39.9999V40H5.99988V48Z",
        fill: "url(#paint0_linear_2404_1191)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M9 30.75C10.8565 30.75 12.637 30.0125 13.9498 28.6997C15.2625 27.387 16 25.6065 16 23.75C16 23.087 15.7366 22.4511 15.2678 21.9822C14.7989 21.5134 14.163 21.25 13.5 21.25C12.837 21.25 12.2011 21.5134 11.7322 21.9822C11.2634 22.4511 11 23.087 11 23.75C11 24.2804 10.7893 24.7891 10.4142 25.1642C10.0391 25.5393 9.53044 25.75 9 25.75C8.46957 25.75 7.96086 25.5393 7.58579 25.1642C7.21071 24.7891 7 24.2804 7 23.75C7 22.9775 7.4075 21.75 8.5 21.75C9.16304 21.75 9.79892 21.4866 10.2678 21.0178C10.7366 20.5489 11 19.913 11 19.25V6.5C11 5.83696 10.7366 5.20107 10.2678 4.73223C9.79892 4.26339 9.16304 4 8.5 4C7.83696 4 7.20108 4.26339 6.73224 4.73223C6.2634 5.20107 6 5.83696 6 6.5V17.2675C3.63 18.3025 2 20.78 2 23.745C1.99934 24.6647 2.17992 25.5755 2.5314 26.4253C2.88289 27.2752 3.3984 28.0474 4.04848 28.698C4.69855 29.3485 5.47045 29.8646 6.32006 30.2167C7.16966 30.5688 8.08033 30.75 9 30.75Z",
        fill: "url(#paint1_linear_2404_1191)"
      }
    ),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "paint0_linear_2404_1191",
        x1: "1.99988",
        y1: "6.8125",
        x2: "28.2011",
        y2: "73.3161",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { offset: "0.272135", stopColor: "#34263B" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "0.658079", stopColor: "#13172C" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "paint1_linear_2404_1191",
        x1: "2",
        y1: "30.75",
        x2: "23.9796",
        y2: "19.2467",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#F81E42" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#FA6981" })
    ))
  ));
}
export {
  p as RideIcTowTruckLight
};
